import React from "react";
import { canonicalLineType } from "./lineType";

export const CUSTOMER_GURU_RESULTS = new Set([
  "MEGA SMASH", "SMASH", "LEAN OVER", "COIN TOSS", "LEAN UNDER", "FADE", "MEGA FADE",
]);

const normalizedHomeAway = (row) => {
  const direct = String(row?.["Home/Away"] ?? row?.homeAway ?? row?.home_away ?? "").trim().toLowerCase();
  if (direct === "home" || direct === "away") return direct;
  const matchup = String(row?.Matchup ?? row?.matchup ?? "").toLowerCase();
  if (matchup.includes("@")) return "away";
  if (matchup.includes(" vs ")) return "home";
  return "";
};

export function compactCustomerMatchup(row, timeText = "", weekdayText = "") {
  const sport = String(row?.Sport ?? row?.League ?? "").trim().toUpperCase();
  const team = String(row?.Team ?? row?.team ?? "").trim();
  const opponent = String(row?.Opponent ?? row?.opponent ?? "").trim();
  const homeAway = normalizedHomeAway(row);
  const sourceMatchup = String(row?.Matchup ?? row?.matchup ?? "").trim();
  const sourceHome = String(row?.["Home Team"] ?? row?.HomeTeam ?? row?.home_team ?? "").trim();
  const sourceAway = String(row?.["Away Team"] ?? row?.AwayTeam ?? row?.away_team ?? "").trim();
  const normalizedTeam = team.toLowerCase().replace(/[^a-z0-9]+/g, "");
  const normalizedHome = sourceHome.toLowerCase().replace(/[^a-z0-9]+/g, "");
  const normalizedAway = sourceAway.toLowerCase().replace(/[^a-z0-9]+/g, "");
  const explicitPerspective = ["NFL", "SOCCER"].includes(sport) && sourceHome && sourceAway
    ? (normalizedTeam === normalizedHome ? "home" : normalizedTeam === normalizedAway ? "away" : "")
    : "";
  const perspective = explicitPerspective || homeAway;
  const matchup = team && opponent && perspective
    ? `${team} ${perspective === "away" ? "@" : "vs"} ${opponent}`
    : sourceMatchup || [team, opponent].filter(Boolean).join(" vs ");
  return [matchup, String(weekdayText || "").trim(), String(timeText || "").trim()].filter(Boolean).join(" • ");
}

export function customerVisibleLineType(row) {
  const type = canonicalLineType(row);
  return ["goblin", "demon"].includes(type) ? type.toUpperCase() : null;
}

export function customerPrimaryLineContext(row) {
  const type = customerVisibleLineType(row);
  const primary = row?.["Primary Market Line"];
  if (!["GOBLIN", "DEMON"].includes(type) || primary === null || primary === undefined || primary === "") return null;
  return `Primary ${primary}`;
}

export function CustomerLineTypeTile({ row }) {
  const type = customerVisibleLineType(row);
  if (!type) return null;
  return (
    <div data-testid="customer-line-type-tile" style={{ border: "1px solid #E2E8F0", borderRadius: 12, padding: "10px 12px", background: "#FFFFFF" }}>
      <div style={{ color: "#64748B", fontSize: 12, fontWeight: 800 }}>Line Type</div>
      <div style={{ color: "#0F172A", fontSize: 16, fontWeight: 950, marginTop: 3 }}>{type}</div>
    </div>
  );
}

export function CustomerGuruResultLabel({ tag }) {
  const value = String(tag || "").trim().toUpperCase();
  return CUSTOMER_GURU_RESULTS.has(value)
    ? <span data-testid="customer-guru-result">{value}</span>
    : <span>{value || "NO CALL"}</span>;
}

export function customerGuruResult(row) {
  const candidates = [row?.Tag, row?.tag, row?.["Guru Tier"], row?.Guru_Tier, row?.["Result Tag"]];
  return candidates
    .map((value) => String(value || "").trim().toUpperCase())
    .find((value) => CUSTOMER_GURU_RESULTS.has(value)) || null;
}

export function showCustomerGuruTierTile(row) {
  const tier = String(row?.["Guru Tier"] ?? row?.Guru_Tier ?? "").trim();
  return Boolean(tier) && !customerGuruResult(row);
}

export function CustomerDetailsGuruBanner({ row, saved = false, onToggle, tagColorMap = {}, darkMode = false, narrow = false }) {
  const result = customerGuruResult(row);
  if (!result) return null;
  const background = tagColorMap[result] || "#64748B";
  return (
    <div data-testid="details-guru-banner" data-narrow={narrow ? "true" : "false"} style={{ padding: narrow ? "10px 12px 4px" : "12px 16px 4px" }}>
      <button
        type="button"
        onClick={(event) => { event.stopPropagation(); onToggle?.(); }}
        aria-pressed={saved}
        aria-label={`${saved ? "Remove" : "Add"} ${result} from My Plays`}
        style={{
          width: "100%", minHeight: narrow ? 48 : 52, borderRadius: 999,
          border: saved ? "2px solid rgba(255,255,255,0.95)" : "2px solid transparent",
          padding: narrow ? "0.72rem 1rem" : "0.8rem 1.15rem", background, color: "#fff",
          fontSize: narrow ? "0.95rem" : "1.05rem", fontWeight: 950, letterSpacing: "0.055em",
          boxShadow: darkMode ? "0 6px 16px rgba(0,0,0,0.28)" : "0 6px 16px rgba(15,23,42,0.12)",
          cursor: "pointer",
        }}
      >
        {saved ? "✓ " : ""}{result}
      </button>
    </div>
  );
}
